import Cropper from 'cropperjs';

// eslint-disable-next-line object-curly-newline
const cropperToBlob = (el, imageType, { height, width, x, y }, callback) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  canvas.width = width;
  canvas.height = height;
  context.drawImage(el, x, y, width, height, 0, 0, canvas.width, canvas.height);
  canvas.toBlob(callback, imageType, 1);
};

const destroyCropper = (cropper, uploadName) => {
  // Destroy the cropper instance
  cropper.destroy();
  // Clear the cropper container
  document.querySelector(`#cropper-container-${uploadName}`).innerHTML = '';
};

export default {
  Cropper: {
    mounted() {
      this.el.addEventListener('input', (e) => {
        e.preventDefault();

        const { uploadName } = this.el.dataset;

        // Show Cropper modal
        const modal = this.el.closest('.fileupload').querySelector(`#cropper-modal-${uploadName}`);
        window.liveSocket.execJS(modal, modal.getAttribute('data-show'));

        const files = Array.from(e.target.files || []);

        if (files.length > 0) {
          const [file] = files;

          // Initialize image inside Cropper container
          const image = new Image();
          image.src = URL.createObjectURL(file);
          this.el
            .closest('.fileupload')
            .querySelector(`#cropper-container-${uploadName}`)
            .appendChild(image);

          // Initialize Cropper
          this.cropper = new Cropper(image, {
            autoCropArea: 1,
            minContainerHeight: 400,
            minContainerWidth: 400,
            viewMode: 1,
          });

          // Modal's button click triggers crop and upload of image
          modal.querySelector('button#cropper-save-button').addEventListener(
            'click',
            () => {
              const dimensions = this.cropper.getData();
              cropperToBlob(image, file.type, dimensions, (blob) => {
                // Setting the name of the blob to the original file name for display purposes
                // eslint-disable-next-line no-param-reassign
                blob.name = file.name;

                // Upload the cropped image
                this.upload(uploadName, [blob]);

                // Close modal
                window.liveSocket.execJS(modal, modal.getAttribute('data-cancel'));

                // Destroy Cropper
                destroyCropper(this.cropper, uploadName);
              });
            },
            // Only call this handler once, then revoke to prevent duplicate event
            // if user uploads another image on the same file input.
            { once: true },
          );

          // Close modal and discard uploaded data
          modal.querySelector('button#cropper-discard-button').addEventListener(
            'click',
            () => {
              // Close modal
              window.liveSocket.execJS(modal, modal.getAttribute('data-cancel'));

              // Destroy Cropper
              destroyCropper(this.cropper, uploadName);
            },
            // Only call this handler once, then revoke to prevent duplicate event
            // if user uploads another image on the same file input.
            { once: true },
          );
        }
      });
    },
    destroyed() {
      if (this.cropper) {
        destroyCropper(this.cropper, this.el.dataset.uploadName);
      }
    },
  },
};
